import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/comment.svg";
var CommentOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  CommentOutline_default as default
};
